import { useRouteError } from "react-router-dom";

interface RouteError {
  statusText?: string;
  message?: string;
}

export default function ErrorPage() {
  const error = useRouteError() as RouteError;
  console.error(error);

  return (
    <div className="grid h-full place-content-center place-items-center gap-8">
      <h1 className="text-2xl font-bold">Oops!</h1>
      <p>Desculpe, um erro inesperado ocorreu.</p>
      <p className="text-gray-500">{error.statusText || error.message}</p>
    </div>
  );
}
